import AbstractRoot from '../../stores/AbstractRoot';

export default class RootStore extends AbstractRoot {
  constructor(localeStore) {
    super({}, {}, localeStore);
  }
}
